import { ForexTableTab } from 'components/ForexTable/ForexTable';

import { LivePricingBlockVariant } from 'interfaces/content-stack/modular-blocks/livePricingBlock';

export const pricingVariantTabs: { [k in LivePricingBlockVariant]: Array<ForexTableTab> } = {
  home: [
    //Currencies on the 'home' variant are deliberately using the CFD rather than CZD currencies.
    //Its not clear what the difference is.
    {
      label: 'Major USD',
      currencies: [
        'CS.D.EURUSD.TODAY.IP',
        'CS.D.GBPUSD.CZD.IP',
        'CS.D.USDJPY.CZD.IP',
        'CS.D.AUDUSD.CZD.IP',
        'CS.D.USDCAD.CZD.IP',
        'CS.D.USDCHF.CZD.IP',
        'CS.D.NZDUSD.CZD.IP',
      ],
    },
    {
      label: 'Major non-USD',
      currencies: [
        'CS.D.GBPJPY.CZD.IP',
        'CS.D.EURJPY.CZD.IP',
        'CS.D.EURGBP.CZD.IP',
        'CS.D.AUDJPY.CZD.IP',
        'CS.D.EURAUD.CZD.IP',
        'CS.D.AUDNZD.CZD.IP',
        'CS.D.AUDCAD.CZD.IP',
        'CS.D.NZDCAD.CZD.IP',
      ],
    },
    {
      label: 'Minor currencies',
      currencies: [
        'CS.D.CADCHF.CZD.IP',
        'CS.D.CADJPY.CZD.IP',
        'CS.D.CHFJPY.CZD.IP',
        'CS.D.EURCAD.CZD.IP',
        'CS.D.EURSGD.CZD.IP',
        'CS.D.EURZAR.CZD.IP',
        'CS.D.GBPCAD.CZD.IP',
        'CS.D.GBPCHF.CZD.IP',
        'CS.D.GBPSGD.CZD.IP',
        'CS.D.GBPZAR.CZD.IP',
        'CS.D.SGDJPY.CZD.IP',
        'CS.D.USDSGD.CZD.IP',
        'CS.D.USDZAR.CZD.IP',
        'CS.D.GBPEUR.CZD.IP',
        'CS.D.EURCHF.CZD.IP',
      ],
    },
    {
      label: 'Emerging currencies',
      currencies: [
        'CS.D.AUDCNH.CZD.IP',
        'CS.D.CNHJPY.CZD.IP',
        'CS.D.EURCNH.CZD.IP',
        'CS.D.USDCNH.CZD.IP',
        'CS.D.EURILS.CZD.IP',
        'CS.D.MXNJPY.CZD.IP',
        'CS.D.NZDCNH.CZD.IP',
        'CS.D.PLNJPY.CZD.IP',
        'CS.D.ZARJPY.CZD.IP',
      ],
    },
    {
      label: 'Australasian currencies',
      currencies: [
        'CS.D.AUDCAD.CZD.IP',
        'CS.D.AUDCHF.CZD.IP',
        'CS.D.AUDJPY.CZD.IP',
        'CS.D.AUDNZD.CZD.IP',
        'CS.D.AUDSGD.CZD.IP',
        'CS.D.EURAUD.CZD.IP',
        'CS.D.EURNZD.CZD.IP',
        'CS.D.GBPAUD.CZD.IP',
        'CS.D.GBPNZD.CZD.IP',
        'CS.D.NZDCHF.CZD.IP',
        'CS.D.NZDJPY.CZD.IP',
        'CS.D.NZDUSD.CZD.IP',
        'CS.D.NZDCAD.CZD.IP',
      ],
    },
    {
      label: 'Scandinavian currencies',
      currencies: [
        'CS.D.CADNOK.CZD.IP',
        'CS.D.CHFNOK.CZD.IP',
        'CS.D.EURDKK.CZD.IP',
        'CS.D.EURNOK.CZD.IP',
        'CS.D.EURSEK.CZD.IP',
        'CS.D.GBPDKK.CZD.IP',
        'CS.D.GBPNOK.CZD.IP',
        'CS.D.GBPSEK.CZD.IP',
        'CS.D.USDDKK.CZD.IP',
        'CS.D.USDNOK.CZD.IP',
        'CS.D.USDSEK.CZD.IP',
        'CS.D.NOKSEK.CZD.IP',
      ],
    },
    {
      label: 'Exotic currencies',
      currencies: [
        'CS.D.CHFHUF.CZD.IP',
        'CS.D.EURCZK.CZD.IP',
        'CS.D.EURHUF.CZD.IP',
        'CS.D.EURMXN.CZD.IP',
        'CS.D.EURPLN.CZD.IP',
        'CS.D.EURTRY.CZD.IP',
        'CS.D.GBPCZK.CZD.IP',
        'CS.D.GBPHUF.CZD.IP',
        'CS.D.GBPMXN.CZD.IP',
        'CS.D.GBPPLN.CZD.IP',
        'CS.D.GBPTRY.CZD.IP',
        'CS.D.TRYJPY.CZD.IP',
        'CS.D.USDCZK.CZD.IP',
        'CS.D.USDHUF.CZD.IP',
        'CS.D.USDILS.CZD.IP',
        'CS.D.USDMXN.CZD.IP',
        'CS.D.USDPLN.CZD.IP',
        'CS.D.USDTRY.CZD.IP',
      ],
    },
  ],
  rates: [
    {
      label: 'Major USD',
      currencies: [
        'CS.D.EURUSD.TODAY.IP',
        'CS.D.GBPUSD.CZD.IP',
        'CS.D.USDJPY.CZD.IP',
        'CS.D.AUDUSD.CZD.IP',
        'CS.D.USDCAD.CZD.IP',
        'CS.D.USDCHF.CZD.IP',
        'CS.D.NZDUSD.CZD.IP',
      ],
    },
    {
      label: 'Major non-USD',
      currencies: [
        'CS.D.GBPJPY.CZD.IP',
        'CS.D.EURJPY.CZD.IP',
        'CS.D.EURGBP.CZD.IP',
        'CS.D.AUDJPY.CZD.IP',
        'CS.D.EURAUD.CZD.IP',
        'CS.D.AUDNZD.CZD.IP',
        'CS.D.AUDCAD.CZD.IP',
        'CS.D.NZDCAD.CZD.IP',
      ],
    },
    {
      label: 'Minor currencies',
      currencies: [
        'CS.D.GBPJPY.CZD.IP',
        'CS.D.EURCAD.CZD.IP',
        'CS.D.CADJPY.CZD.IP',
        'CS.D.GBPCAD.CZD.IP',
        'CS.D.CHFJPY.CZD.IP',
        'CS.D.GBPCHF.CZD.IP',
        'CS.D.CADCHF.CZD.IP',
        'CS.D.USDZAR.CZD.IP',
        'CS.D.EURSGD.CZD.IP',
        'CS.D.EURZAR.CZD.IP',
        'CS.D.GBPSGD.CZD.IP',
        'CS.D.GBPZAR.CZD.IP',
        'CS.D.SGDJPY.CZD.IP',
        'CS.D.USDSGD.CZD.IP',
        'CS.D.GBPEUR.CZD.IP',
        'CS.D.EURCHF.CZD.IP',
      ],
    },
    {
      label: 'Emerging currencies',
      currencies: [
        'CS.D.USDCNH.CZD.IP',
        'CS.D.CADCNH.CZD.IP',
        'CS.D.CNHJPY.CZD.IP',
        'CS.D.GBPCNH.CZD.IP',
        'CS.D.EURCNH.CZD.IP',
        'CS.D.AUDCNH.CZD.IP',
        'CS.D.EURILS.CZD.IP',
        'CS.D.MXNJPY.CZD.IP',
        'CS.D.NZDCNH.CZD.IP',
        'CS.D.PLNJPY.CZD.IP',
        'CS.D.ZARJPY.CZD.IP',
      ],
    },
    {
      label: 'Australasian currencies',
      currencies: [
        'CS.D.AUDCAD.CZD.IP',
        'CS.D.AUDCHF.CZD.IP',
        'CS.D.AUDNZD.CZD.IP',
        'CS.D.AUDSGD.CZD.IP',
        'CS.D.EURAUD.CZD.IP',
        'CS.D.EURNZD.CZD.IP',
        'CS.D.GBPAUD.CZD.IP',
        'CS.D.GBPNZD.CZD.IP',
        'CS.D.NZDCHF.CZD.IP',
        'CS.D.NZDJPY.CZD.IP',
        'CS.D.NZDUSD.CZD.IP',
        'CS.D.NZDCAD.CZD.IP',
      ],
    },
    {
      label: 'Scandinavian currencies',
      currencies: [
        'CS.D.CADNOK.CZD.IP',
        'CS.D.CHFNOK.CZD.IP',
        'CS.D.EURDKK.CZD.IP',
        'CS.D.EURSEK.CZD.IP',
        'CS.D.GBPDKK.CZD.IP',
        'CS.D.GBPNOK.CZD.IP',
        'CS.D.GBPSEK.CZD.IP',
        'CS.D.USDDKK.CZD.IP',
        'CS.D.USDNOK.CZD.IP',
        'CS.D.USDSEK.CZD.IP',
        'CS.D.NOKSEK.CZD.IP',
      ],
    },
    {
      label: 'Exotic currencies',
      currencies: [
        'CS.D.CHFHUF.CZD.IP',
        'CS.D.EURCZK.CZD.IP',
        'CS.D.EURHUF.CZD.IP',
        'CS.D.EURMXN.CZD.IP',
        'CS.D.EURPLN.CZD.IP',
        'CS.D.EURTRY.CZD.IP',
        'CS.D.GBPCZK.CZD.IP',
        'CS.D.GBPMXN.CZD.IP',
        'CS.D.GBPPLN.CZD.IP',
        'CS.D.TRYJPY.CZD.IP',
        'CS.D.USDHUF.CZD.IP',
        'CS.D.USDILS.CZD.IP',
        'CS.D.USDMXN.CZD.IP',
        'CS.D.USDPLN.CZD.IP',
        'CS.D.USDTRY.CZD.IP',
      ],
    },
  ],
  dashboard: [
    {
      label: 'Major currencies',
      currencies: [
        'CS.D.GBPUSD.CZD.IP',
        'CS.D.EURUSD.CZD.IP',
        'CS.D.USDJPY.CZD.IP',
        'CS.D.USDCAD.CZD.IP',
        'CS.D.AUDUSD.CZD.IP',
      ],
    },
    {
      label: 'Minor Currencies',
      currencies: [
        'CS.D.GBPUSD.CZD.IP', //This one really is both major & minor on the IG site
        'CS.D.GBPJPY.CZD.IP',
        'CS.D.EURCAD.CZD.IP',
        'CS.D.GBPCAD.CZD.IP',
        'CS.D.USDZAR.CZD.IP',
      ],
    },
    {
      label: 'Emerging Currencies',
      currencies: [
        'CS.D.USDCNH.CZD.IP',
        'CS.D.GBPCNH.CZD.IP',
        'CS.D.CNHJPY.CZD.IP',
        'CS.D.AUDCNH.CZD.IP',
        'CS.D.EURILS.CZD.IP',
        'CS.D.MXNJPY.CZD.IP',
        'CS.D.NZDCNH.CZD.IP',
        'CS.D.PLNJPY.CZD.IP',
        'CS.D.ZARJPY.CZD.IP',
      ],
    },
    {
      label: 'Australasian Currencies',
      currencies: ['CS.D.AUDJPY.CZD.IP', 'CS.D.AUDCAD.CZD.IP', 'CS.D.NZDUSD.CZD.IP', 'CS.D.EURAUD.CZD.IP'],
    },
    {
      label: 'Scandinavian Currencies',
      currencies: [
        'CS.D.USDSEK.CZD.IP',
        'CS.D.USDNOK.CZD.IP',
        'CS.D.NOKJPY.CZD.IP',
        'CS.D.USDDKK.CZD.IP',
        'CS.D.SEKJPY.CZD.IP',
        'CS.D.NOKSEK.CZD.IP',
      ],
    },
    {
      label: 'Exotic Currencies',
      currencies: [
        'CS.D.EURPLN.CZD.IP',
        'CS.D.USDMXN.CZD.IP',
        'CS.D.TRYJPY.CZD.IP',
        'CS.D.USDPLN.CZD.IP',
        'CS.D.GBPILS.CZD.IP',
      ],
    },
  ],
  overnight: [
    {
      label: 'Major forex pairs',
      currencies: [
        'CS.D.EURUSD.CZD.IP',
        'CS.D.GBPUSD.CZD.IP',
        'CS.D.USDCHF.CZD.IP',
        'CS.D.USDJPY.CZD.IP',
        'CS.D.AUDUSD.CZD.IP',
        'CS.D.USDCAD.CZD.IP',
      ],
    },
    {
      label: 'Minor forex pairs',
      currencies: [
        'CS.D.USDZAR.CZD.IP',
        'CS.D.NZDUSD.CZD.IP',
        'CS.D.USDSGD.CZD.IP',
        'CS.D.USDNOK.CZD.IP',
        'CS.D.USDSEK.CZD.IP',
        'CS.D.USDHKD.CZD.IP',
      ],
    },
    {
      label: 'Non-USD forex pairs',
      currencies: [
        'CS.D.EURGBP.CZD.IP',
        'CS.D.EURJPY.CZD.IP',
        'CS.D.EURCHF.CZD.IP',
        'CS.D.GBPJPY.CZD.IP',
        'CS.D.AUDJPY.CZD.IP',
        'CS.D.AUDCAD.CZD.IP',
      ],
    },
  ],
  'overnight-spread': [
    {
      label: 'Major forex pairs',
      currencies: [
        'CS.D.EURUSD.CZD.IP',
        'CS.D.GBPUSD.CZD.IP',
        'CS.D.USDCHF.CZD.IP',
        'CS.D.USDJPY.CZD.IP',
        'CS.D.AUDUSD.CZD.IP',
        'CS.D.USDCAD.CZD.IP',
      ],
    },
    {
      label: 'Minor forex pairs',
      currencies: [
        'CS.D.USDZAR.CZD.IP',
        'CS.D.NZDUSD.CZD.IP',
        'CS.D.USDSGD.CZD.IP',
        'CS.D.USDNOK.CZD.IP',
        'CS.D.USDSEK.CZD.IP',
        'CS.D.USDHKD.CZD.IP',
      ],
    },
    {
      label: 'Non-USD forex pairs',
      currencies: [
        'CS.D.EURGBP.CZD.IP',
        'CS.D.EURJPY.CZD.IP',
        'CS.D.EURCHF.CZD.IP',
        'CS.D.GBPJPY.CZD.IP',
        'CS.D.AUDJPY.CZD.IP',
        'CS.D.AUDCAD.CZD.IP',
      ],
    },
  ],
};

export const tickerEpics: string[] = [
  'CS.D.AUDUSD.CZD.IP',
  'CS.D.EURGBP.CZD.IP',
  'CS.D.EURJPY.CZD.IP',
  'CS.D.EURUSD.CZD.IP',
  'CS.D.GBPUSD.CZD.IP',
  'CS.D.USDCAD.CZD.IP',
  'CS.D.USDCHF.CZD.IP',
  'CS.D.USDJPY.CZD.IP',
];

export const epicToLabel = (epic: string) => {
  const currency = epic.split('.')[2].replace('sp_', '');
  return `${currency.substring(0, 3)}/${currency.substring(3)}`;
};
